import { render, staticRenderFns } from "./CurrentProductionStockAdjust.vue?vue&type=template&id=d61a9f92&"
import script from "./CurrentProductionStockAdjust.vue?vue&type=script&lang=js&"
export * from "./CurrentProductionStockAdjust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports